import React from 'react'
import SocialNetwork from '../SocialNetwork'
import Picture from './Picture'
import Quit from './Button/quit'
import Change from './Button/change'

import { showcase } from './data.js';

import './styles.css'

// import fakePhotographe from '../../assets/images/fakePhotographe.jpg'

import type PhotographersApp  from '../../utils/photographersApp'
import type DailyItemsApp  from '../../utils/dailyItemsApp'
import type { ContextRouter } from 'react-router-dom'

const classNames = require('classnames');

type PropsType = {
  ...ContextRouter,
  PhotographersApp: PhotographersApp,
  DailyItemsApp: DailyItemsApp,
}

type StateType = { 
}

export default class Photographer extends React.Component<PropsType, StateType> {
  
  constructor(props: PropsType) {
    super(props)
    
    this.nameRef = React.createRef();   
    this.portfolio = React.createRef(); 
    this.quitBtn = React.createRef(); 
    this.fsContainer = React.createRef(); 
    this.introFullname = React.createRef(); 
    this.portfolioFullname = React.createRef(); 
    this.mainWrapper = React.createRef(); 
    this.introBackBtn = React.createRef();
    this.portfolioBackBtn = React.createRef();
    this.switchColor = false;
    this.enabledFullscreen = false;
    this.elementFullscreen = undefined;
    this.quitBtnColor = "#D5735B";
    this.quitBtnOpacity = 0;
    this.sourceFs = '';
    this.indexImageSelected = -1;
    this.fade = false;
    this.data = showcase;
    this.delayAnimationFade = undefined;
    this.state = {
      quitBtnColor: this.quitBtnColor,
      pics: [],
    }
  }

  componentDidMount () {
    this.setState({pics: this.fetchPicsDom()});

    setTimeout(() => {
      // this.mainWrapper.current.style.top = '0';
      // this.mainWrapper.current.style.position = 'fixed';
    }, 250);


    window.addEventListener('keydown', e => this.handleEventsOnKeydown(e), true);
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', e => this.handleEventsOnKeydown(e), true);
  }

  fetchPicsDom () {
    return document.querySelectorAll('.picture-container');
  }

  handleEventsOnScroll (e) {
    this.scrollFullname(e);
    this.scrollBackBtn(e);
    this.revealPics(e);
  }

  handleEventsOnKeydown(e) {
    if (this.indexImageSelected === -1) return;
    switch(e.keyCode) {
      case 27:
        clearTimeout(this.delayAnimationFade);
        this.handleDisabledFullscreen();
        break;
      case 37:
        if(!this.fade) this.previousImage();
        break;
      case 39:
        if(!this.fade) this.nextImage();
        break;
      default:
        break;
    }
  }

  scrollFullname(e) {
    if(this.introFullname.current !== null && this.mainWrapper.current !== null && this.portfolioFullname !== null) {
      this.introFullname.current.style.top = this.mainWrapper.current.scrollTop + 100 + 'px';
      this.portfolioFullname.current.style.top = -this.portfolio.current.getBoundingClientRect().y + 100 + 'px';
    }
  }
  
  scrollBackBtn(e) {
    if(this.introBackBtn.current !== null && this.mainWrapper.current !== null && this.portfolioBackBtn !== null) {
      this.introBackBtn.current.style.top = this.mainWrapper.current.scrollTop + 38 + 'px';
      this.portfolioBackBtn.current.style.top = -this.portfolio.current.getBoundingClientRect().y + 38 + 'px';
    }
  }

  revealPics(e) {
    const pics = this.fetchPicsDom();

    pics.forEach((element, index) => {
      if (this.mainWrapper.current.scrollTop + window.innerHeight > this.portfolio.current.offsetTop + element.offsetTop) {
        element.classList.add('slideInUp');
        setTimeout(() => {
          element.classList.add('done');
          element.classList.remove('slideInUp');
        }, 400);
      }
    });
  }

  changeNameColor() {
    const element = this.nameRef.current;
    const trigger = this.portfolio.current;
    const quitBtn = this.quitBtn.current;
    if(element !== null && trigger !== null && quitBtn !== null) {
      const elementPos = {
        x : element.getBoundingClientRect().x,
        y : element.getBoundingClientRect().y,
      }
      
      const triggerPos = {
        x : trigger.getBoundingClientRect().x,
        y : trigger.getBoundingClientRect().y,
      }

      if (triggerPos.y <= elementPos.y + 60) { // +60 removing top word spacing
        this.switchColor = true;
      } else {
        this.switchColor = false;
      }
    }


  }

  handleEnabledFullscreen (e) {
    if(this.state.pics !== undefined) {
      this.enabledFullscreen = true;
      this.quitBtnOpacity = 1;
      this.setState({quitBtnColor: this.quitBtnColor});
      this.state.pics.forEach((element, index) => {
        if(element !== e.currentTarget) {
          element.classList.add('hide');
        } else {
          this.elementFullscreen = element;
          this.sourceFs = element.firstChild.getAttribute('src');
          this.indexImageSelected = index;
        }
      });


      this.elementFullscreen.classList.add('selected');
      setTimeout(() => {
        this.fsContainer.current.classList.add('appear');
      }, 250);
    }
  }

  handleDisabledFullscreen (e) {
    if(this.enabledFullscreen) {
      this.enabledFullscreen = !this.enabledFullscreen;
      this.quitBtnOpacity = 0;
      this.indexImageSelected = -1;
      
      this.state.pics.forEach(element => {
        this.elementFullscreen.classList.remove('selected')
        element.classList.remove('hide');
        this.fsContainer.current.classList.remove('appear');        
      });

      this.elementFullscreen = null;
    }
  }

  previousImage() {
    this.fade = true;
    
    if(this.indexImageSelected - 1 < 0) this.indexImageSelected = this.state.pics.length;

    this.delayAnimationFade = setTimeout(() => {
      this.sourceFs = this.state.pics[this.indexImageSelected - 1].firstChild.getAttribute('src');
      this.indexImageSelected -= 1;
      setTimeout(() => {
        this.fade = false;
      }, 250);
    }, 250);
  }

  nextImage() {
    this.fade = true;

    if(this.indexImageSelected + 1 === this.state.pics.length) this.indexImageSelected = -1;

    this.delayAnimationFade = setTimeout(() => {
      this.sourceFs = this.state.pics[this.indexImageSelected + 1].firstChild.getAttribute('src');
      this.indexImageSelected += 1;
      setTimeout(() => {
        this.fade = false;
      }, 250);
    }, 250);
  }

  closePhotographer() {
    // this.mainWrapper.current.style.top = '100%';
    this.props.trigger(false);
    // this.mainWrapper.current.style.position = 'fixed';
    // setTimeout(() => {
    //   if(this.props.location.state && this.props.location.state.articleUID) {
    //     this.props.history.push(`/article/${this.props.location.state.articleUID}` );
    //   } else {
    //     this.props.returnToArticle();
    //   }
    // }, 500);
  }

  // COMPUTED

  // @TODO Retrieve photographer name - If not retrieve, replace by a gray background block
  getPhotographerName() {
    const colors = classNames({
      'photographer-fullname' : true,
      'change-color': this.switchColor,
    })
    return(
      <h1 ref={this.nameRef} className={colors}>noel celis</h1>
    )
  }

  getPhotographerPic(_this) {
    let pics = this.data.map(function(source) {
      return (
        <div key={source} className="picture-container" onClick={(e) => _this.handleEnabledFullscreen(e)}>
          <Picture source={"/showcase/" + source} />
        </div>
      );
    })

    return <div className="photographer-works">{pics}</div>
  }

  render() {

    const noScroll = classNames({
      'photographer-container': true,
      'no-scroll': this.enabledFullscreen,
      'photographer-container-reveal' : this.props.reveal,
    });

    const imageTransition = classNames({
      'fs-image': true,
      'fade': this.fade,
    })

    return (
      <div
        ref={this.mainWrapper}
        className={noScroll}
        onScroll={(e) => this.handleEventsOnScroll(e)}
      >
        

        <div className="photographer-intro">
          <h1 ref={this.introFullname} className="photographer-fullname">noel celis</h1>

          <h3
            ref={this.introBackBtn}
            onClick={() => this.closePhotographer() }
            className="back-btn"
            style={{
              top: '38px', 
              left: '38px',
              position: 'absolute',
              zIndex: '8',
            }}
          >
            BACK
          </h3>

          <div className="photographer-wrapper">
            <div className="photographer-bio-wrapper">
              <div className="photographer-bio">
                <h1>Noel Celis is a Manila-based Agence France-Presse (AFP) photographer from the Philippines.</h1>
                <p>
                  Noel ventured into news photography for two local newspapers, The Manila Times in 2005 and The Manila Bulletin in 2007, covering different beats like police, sports and lifestyle. In 2009, Noel joined AFP as a photo correspondent where he was able to shoot disasters like typhoon Ketsana. He was among the first photographers to arrive immediately after Typhoon Haiyan hit the Philippines.
                </p>
                <div className="photographer-getInTouch">
                  <div className="instagram-wrapper">
                    <SocialNetwork type="instagram" url="https://www.instagram.com/" />
                    @noelcelis
                  </div>
                  <a className="link-underline" href="#missingLink" target="_blank">noelcelis.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ 
          opacity: this.quitBtnOpacity, 
          pointerEvents: this.props.reveal ? 'all' : 'none'
          }} className="quit-container" onClick={(e) => this.handleDisabledFullscreen(e)}>
          <Quit refBtn={this.quitBtn} color={this.state.quitBtnColor}></Quit>
        </div>

        <div ref={this.fsContainer} className="fs-container">
          <div className="change-btn-wrapper">
            <div className="change change-btn-left" onClick={() => this.previousImage()}>
              <Change></Change>
            </div>
            <div className="change change-btn-right" onClick={() => this.nextImage()}>
              <Change></Change>
            </div>
          </div>
          <div className={imageTransition} style={{ backgroundImage: `url(${this.sourceFs})`}}>
          </div>
        </div>

        <div ref={this.portfolio} className="photographer-portfolio">
          <h3
            ref={this.portfolioBackBtn}
            onClick={() => this.closePhotographer() }
            className="back-btn"
            style={{
              top: '38px', 
              left: '38px',
              position: 'absolute',
              zIndex: '12',
              color: '#D5735B'
            }}
          >
            BACK
          </h3>
          <div className="photographer-name-portfolio">
            <h1 ref={this.portfolioFullname} className="photographer-fullname">noel celis</h1>       
          </div>
          <div className="photographer-showcase">
              
              {this.getPhotographerPic(this)}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Photographer/index.jsx